var map = {
	"./_dance.svg": "3ed4",
	"./_heart.svg": "2909",
	"./_joke.svg": "ae0d",
	"./_microphone.svg": "d9e8",
	"./_minus.svg": "6505",
	"./_photo.svg": "2197",
	"./_play.svg": "1b70",
	"./_plus.svg": "ece6",
	"./_smile_bad.svg": "5766",
	"./_smile_fine.svg": "2be3",
	"./_smile_great.svg": "4c1a",
	"./_song.svg": "9971",
	"./_tickets.svg": "7718",
	"./_video.svg": "0ff8",
	"./abort.svg": "bd91",
	"./back.svg": "7338",
	"./cross.svg": "2ad7",
	"./important.svg": "0c39",
	"./point.svg": "7c2f",
	"./replic.svg": "8757",
	"./success.svg": "1c27"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6f32";